import { put, get } from "../../http";
import { root } from "../../config.json";

export const getHospitalFeedbacks = (hid) => {
    return get(`${root}/api/v3/feedback/HFeedbacks/${hid}`);
  };

  export const AddDoctorComment = (did,body) => {
    return put(`${root}/api/:v3/feedback/${did}`, body);
  };